export class NewsList {
  news: string;
  constructor() {
    this.news = null;
  }
}
